import React from 'react';
import { useMenuState } from '@ers/hooks';

export const MenuStateContext = React.createContext({
    state: '',
    opened: false,
    open: () => {},
    close: () => {}
});

export default function MenuStateContextContainer({ children }) {
    const { state, open, close, opened } = useMenuState();

    return <MenuStateContext.Provider value={{ state, open, close, opened }}>{children}</MenuStateContext.Provider>;
}
